import script from "./EditableCompanyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableCompanyItem.vue?vue&type=script&setup=true&lang=js"

import "./EditableCompanyItem.vue?vue&type=style&index=0&id=4a757f0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a757f0e"]])

export default __exports__